import { type IconProps, type IllustrationIconProps, IllustrationIcons } from "@obs/icons";
import { capitalizeFirstLetter, getCountryCode } from "@obs/utils";
import { createElement, type ReactElement } from "react";

type FlagAffixIcon = (props: IconProps) => ReactElement;
type FlagIllustrationIcon = (props: IllustrationIconProps) => ReactElement;

const flagIconCache = new Map<string, FlagAffixIcon | undefined>();

export const getFlagIllustrationIcon = (localeCode: string): FlagAffixIcon | undefined => {
	if (flagIconCache.has(localeCode)) {
		return flagIconCache.get(localeCode);
	}

	const countryCode = getCountryCode(localeCode);
	const illustrationIconName =
		`Flag${capitalizeFirstLetter(countryCode.toLowerCase())}IllustrationIcon` as keyof typeof IllustrationIcons;
	const IllustrationIcon = IllustrationIcons[illustrationIconName] as FlagIllustrationIcon | undefined;

	if (!IllustrationIcon) {
		flagIconCache.set(localeCode, undefined);
		return undefined;
	}

	const affixIcon: FlagAffixIcon = ({ size = 24, iconColor: _iconColor, ...rest }) => {
		return createElement(IllustrationIcon, { size, ...rest });
	};

	flagIconCache.set(localeCode, affixIcon);

	return affixIcon;
};
